module.exports = __webpack_public_path__ + "static/img/Boy-1.d07f3677.png";